import { useQuery } from '@common-fe/common-fe';

import { api } from '@/api';
import { API_URL } from '@/dtos';

interface Props {
  templateId?: string;
  enabled?: boolean;
}

const useGetSmsPreviewQuery = ({ templateId, enabled }: Props) => {
  const { data, isLoading, isError, refetch } = useQuery(
    [API_URL.EXTERNAL_TEMPLATES_SMS_PREVIEW_BY_ID(templateId as string)],
    () => api.get(API_URL.EXTERNAL_TEMPLATES_SMS_PREVIEW_BY_ID(templateId as string)),
    { enabled: Boolean(enabled && templateId) }
  );

  return {
    smsText: data?.data,
    isSMSTextLoading: isLoading,
    isSmsTextError: isError,
    onRefetchSmsText: refetch,
  };
};

export default useGetSmsPreviewQuery;
